// Module
var code = `<div class="oe-selector" style="{{>visibility}}">
    <terceraLabel text="{{label}}" />

    <div class="oe-selector-right">
        <terceraComboBox showLastValue="true"
                         items="{{dp.objectVariants}}"
                         selectedItem="{{boundToItem}}" />
    </div>
</div>`;
// Exports
export default code;